import { useGetUserQuery, useGetUsersQuery } from 'api/UsersEndPoints';
import UserForm from 'modules/Users/createUser/UserForm';
import { useParams } from 'react-router-dom';
import Loader from 'shared/component/Loader';

const CreateOrEditUser = () => {
  const { id } = useParams();
  const isNew = id === 'new';

  const { data: dataUsers = [], isLoading: isLoadingUsers } = useGetUsersQuery();

  const { data, isLoading } = useGetUserQuery(id as string, {
    skip: isNew || undefined,
  });

  const model = isNew
    ? {
        firstName: '',
        lastName: '',
        email: '',
        company: '',
      }
    : data;

  if (isLoading || isLoadingUsers) {
    return <Loader />;
  }

  if (!model) {
    return null;
  }

  return <UserForm model={model} existingUsers={dataUsers} />;
};

export default CreateOrEditUser;
